
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import translate from '../../helpers/translate';
import HappyHourScreen from './happy';
import SoftDrinksScreen from './softDrinks';
import LunchScreen from './lunch';

function Index({setshowCategories}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menus, setMenus] = useState([]);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
     const [dishs, setdishs] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showSoftDrinks, setShowSoftDrinks] = useState(false);
    const [showLunch, setShowLunch] = useState(false);
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, []);

    
     const fetchImage = async (id) => {
            const imageBlob = await getImage(id);
            if (imageBlob) {
                const imageURL = URL.createObjectURL(imageBlob.data.blob);
                return imageURL;
            }
            return null;
     };
    
    const Item = (props) => {
        const { item } = props;
        const [image, setImage] = useState(false);
                useEffect(() => {
                    fetchImage(`menu-cat-${item.id}`).then((url) => {
                        if (url) {
                            setImage(url);
                            
                        }
                    });
                }, []);
        
        return <div  style={{
                                display: 'flex',
                                alignItems: "center",
                                justifyContent: 'center',
                                width: 340,
                                position: "relative"
                            }}
                                onClick={() => { 
                                    if(item.id === 153) {
                                        setShowHappy(true);
                                    }else if(item.id === 112) {
                                        setShowLunch(true);
                                    }else if(item.id === 111) {
                                        setShowSoftDrinks(true);
                                    } else {
                                        setShowListProduct(true);
                                        setdishs(item);
                                    }
                                }}
                                >
                                    {/* fontFamily: 'WallAxe', */}
            <p className='text-shadow' style={{ position: 'absolute', color: 'white', fontWeight: "900", fontSize: 30, textTransform: 'uppercase' }}>
                {langEng ? item.name : translate(i18n.language, item.language, item.name)}
            
            
            </p>
                                <img
                                    src={image}
                                    style={{
                                        marginTop: 10,
                                        width: '100%',
                                        height: 210,
                                        objectFit: 'cover',
                                        borderRadius: 20,
                                    }}
                                />

                            </div>
                            
    }
    return (
        <div style={{ position: 'absolute', top: 1, left: 0, width: '100%', height: '100%', zIndex: 9999 }}>
            <LayoutContent showLamp={ false} showBack={true} showImageTop={false}  setShowListProduct={setshowCategories} goHome={setshowCategories} setShowSpecials={setShowSpecials}>
                <div style={{backgroundColor: 'white', height: 800, borderRadius: 20,}}>
                     <div  style={{padding: '0 20px', overflow: 'scroll', height: 800}}>
                    <div style={{display:"flex", justifyContent: 'space-between', flexWrap: "wrap"}}>
                        {menus.map((item, key) => {
                            if (![443, 444, 445, 594, 446, 447, 448, 449, 450, 429, 430, 425, 424, 555, 565, 564, 566, 567, 597].includes(item.id)) {
                                return <Item item={item} key={key} />
                            }
                            
                        })}
                    </div>
                   
                </div>
               </div>

                {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                    goHome={setshowCategories}
                />}

                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setshowCategories} />}
                {showHappy && <HappyHourScreen setShowHappy={setShowHappy} />}      
                {showSoftDrinks && <SoftDrinksScreen setShowHappy={setShowSoftDrinks} />}
                {showLunch && <LunchScreen setShowHappy={setShowLunch} />}
            </LayoutContent>
        </div>
    );
}
export default Index;